import { useContext } from 'react';

import { PromoCartContext } from '../contexts/PromoCartProvider';

export const usePromoCart = () => useContext(PromoCartContext);
